/**
 * Initialize IDE settings for the app.
 */
import Radio from 'backbone.radio';
import ide_settings from '@/models/ide_settings';

    export default function() {
        const global_ch = Radio.channel('global');

        global_ch.reply('ide_settings', function() {
            return ide_settings;
        });
    }

